/**
 * Synthetic NILM appliance-classification sample — SYNTHETIC ONLY.
 *
 * Byte-mirrors the committed backend test fixtures
 * (`tests/fixtures/classification/nilm_predictions.csv` + `nilm_benchmark_labels.csv`), so a
 * "use the synthetic sample" run in the browser produces the SAME deterministic figures the
 * server-side `researchharness classification-evidence` command certifies (accuracy 0.85 over
 * 20 samples across four appliances). Fabricated for the offline demo — NOT real PLAID data,
 * NOT customer energy data.
 */

export const NILM_SAMPLE_PREDICTIONS_CSV = `sample_id,predicted_label,score
s01,fridge,0.98
s02,fridge,0.91
s03,fridge,0.88
s04,fridge,0.79
s05,microwave,0.55
s06,microwave,0.93
s07,microwave,0.90
s08,microwave,0.85
s09,microwave,0.81
s10,fridge,0.52
s11,hairdryer,0.95
s12,hairdryer,0.89
s13,hairdryer,0.87
s14,hairdryer,0.80
s15,laptop,0.49
s16,laptop,0.97
s17,laptop,0.92
s18,laptop,0.90
s19,laptop,0.84
s20,laptop,0.83
`;

export const NILM_SAMPLE_LABELS_CSV = `sample_id,true_label
s01,fridge
s02,fridge
s03,fridge
s04,fridge
s05,fridge
s06,microwave
s07,microwave
s08,microwave
s09,microwave
s10,microwave
s11,hairdryer
s12,hairdryer
s13,hairdryer
s14,hairdryer
s15,hairdryer
s16,laptop
s17,laptop
s18,laptop
s19,laptop
s20,laptop
`;

/** The synthetic benchmark's identity, shown in the provenance tab (honest labels). */
export const NILM_SAMPLE_BENCHMARK = {
  name: 'synthetic-nilm-appliance-classification',
  release: 'synthetic-v1',
  publisher: 'HenniPenny synthetic fixtures',
  note: 'Fabricated appliance labels for the offline walkthrough — NOT real PLAID data.',
  realPin: 'benchmarks/plaid_classification_v1.json (PLAID; pinned by URL + SHA, not vendored)',
} as const;
